import Vuex from 'vuex';
import Vue from "vue";
import actions from "./actions";
import mutations from "./mutations";
import getters from './getters';
import customerDefaultValues from "./customerDefaultValues";
import currentEventDefault from "./currentEventDefault";
import _ from 'lodash'

Vue.use(Vuex);

let customers = [_.cloneDeep(customerDefaultValues)];

export default new Vuex.Store({
    state: {
        params: '',
        cart: {},
        directions: [],
        events: [],
        currentEvent: currentEventDefault,
        currentEventId: localStorage.getItem('current_event_id') || '',
        eventPaid: false,
        membersCount: localStorage.getItem('members_count') || 1,
        isLoader: false,
        availableMembersCount: '',
        currentRouteName: '',
        customers: JSON.parse(localStorage.getItem('customers')) || customers,
        invoice: {},
        order: null,
        customerId: '',
        promo: '',
        blank: {
            self: true,
            social: '',
            practice: '',
            friends: '',
            howFinds: {
                friends: false,
                instagram: false,
                facebook: false,
                other: false
            }
        },
        orderAddressError: '',
        blankSaved: false,
        availablePlacesCount: 0,
        isOverdueTime: false,
        overdueTime: 60 * 1000 * 20,//20 minutes
        partialPay: {
            percent: 100,
            sum: 0,
        },
        DEFAULT_MEMBERS_COUNT: 1
    },
    mutations: mutations,
    actions: actions,
    getters: getters
});
